export interface BreadcrumbEntry {
  label: string;
  path: string;
}

interface SeoProps {
  title: string;
  description: string;
  keywords?: string[];
  canonicalPath?: string;
  image?: string;
  imageAlt?: string;
  breadcrumbs?: BreadcrumbEntry[];
  jsonLd?: Record<string, unknown>[];
}

const SITE_URL = "https://chengshunjt.cn";
const SITE_NAME = "网红大瓜";

export default function Seo({
  title,
  description,
  keywords = [],
  canonicalPath = "/",
  image = "",
  imageAlt = "网红大瓜",
  breadcrumbs = [],
  jsonLd = [],
}: SeoProps) {
  const canonical = `${SITE_URL}${canonicalPath === "/" ? "/" : canonicalPath}`;

  const breadcrumbSchema =
    breadcrumbs.length > 0
      ? [
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: breadcrumbs.map((item, index) => ({
              "@type": "ListItem",
              position: index + 1,
              name: item.label,
              item: `${SITE_URL}${item.path}`,
            })),
          },
        ]
      : [];

  const schemas = [...breadcrumbSchema, ...jsonLd];

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords.length > 0 && <meta name="keywords" content={keywords.join(",")} />}
      <meta name="robots" content="index, follow, max-image-preview:large" />
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:locale" content="zh_CN" />
      {image && <meta property="og:image" content={image} />}
      {image && <meta property="og:image:alt" content={imageAlt} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}
      {schemas.map((schema, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      ))}
    </>
  );
}